module.exports = __webpack_public_path__ + "e79aa136a8f4b4041ec524c534614357.svg";